import { createUseStyles } from 'react-jss'

import { MQ, COLOR } from 'utils/constants'

export const useStyles = createUseStyles({
  wrapper: {
    margin: 'auto',
    paddingBottom: 60,
    width: '80%',
    [MQ.TABLET]: {
      width: '78.88%',
    },
    [MQ.TABLET_LARGE]: {
      width: '75%',
      maxWidth: 1170,
    },
    '& h2': {
      lineHeight: 1.4,
    },
  },
  title: {
    margin: [0, 0, 20],
    color: COLOR.LIGHT_GREEN,
    [MQ.TABLET]: {
      marginLeft: 0,
    },
  },
  gridContainer: {
    display: 'grid',
    margin: 'auto',
    [MQ.TABLET]: {
      gridTemplateColumns: '45% 45%',
      columnGap: '10%',
      gridTemplateRows: 'auto',
    },
    [MQ.TABLET_LARGE]: {
      gridTemplateColumns: '27.8% 27.8% 27.8%',
      columnGap: '8.33%',
    },
  },
})
